import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { OverlayStyle } from './style'

const Overlay = props => {
    const { children, handleClick, topheader } = props

    // const classNames = `${OverlayStyle}`
    const className = classNames(OverlayStyle)

    return (
        <div className={className} onClick={handleClick} topheader={topheader}>
            {children}
        </div>
    )
}

Overlay.propTypes = {
    children: PropTypes.any,
    handleClick: PropTypes.func,
    topHeader: PropTypes.bool,
}

export default Overlay
